import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Metronome from "@/components/Metronome";
import SequencerPage from "@/pages/SequencerPage";
import TunerPage from "@/pages/TunerPage";
import DronePage from "@/pages/DronePage";
import InfoPage from "@/pages/InfoPage";
import { DonationBanner } from "@/components/DonationBanner";
import { DroneProvider } from "@/hooks/useDrone";
import { ActiveSoundsBar } from "@/components/ActiveSoundsBar";

const PING_URL =
  "https://mauriziopinkrosa.it/?utm_source=pwa_metronomo&utm_medium=app_usage&utm_campaign=metronomo_back_link";

const sendPing = () => {
  fetch(PING_URL, { mode: "no-cors", cache: "no-store", keepalive: true }).catch(() => {});
};

function App() {
  useEffect(() => {
    sendPing();
    const id = setInterval(sendPing, 300000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <DroneProvider>
          <Routes>
            <Route path="/" element={<Metronome />} />
            <Route path="/sequencer" element={<SequencerPage />} />
            <Route path="/tuner" element={<TunerPage />} />
            <Route path="/bordone" element={<DronePage />} />
            <Route path="/info" element={<InfoPage />} />
          </Routes>
          <ActiveSoundsBar />
        </DroneProvider>
      </BrowserRouter>
      <DonationBanner />
    </div>
  );
}

export default App;
